<template>
  <div>
    <loading-spinner v-if="isLoading" :status="$t('functional.authenticating')"></loading-spinner>
    <MaintenanceScreen
      v-if="featureEnabled('planned-maintenance')"
      class="h-full flex items-center justify-center"/>
    <div
      v-else
      id="app"
      data-test="main-screen">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import * as Sentry from '@sentry/browser'
import { MaintenanceScreen } from '@/components/screens/MaintenanceScreen'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'app',
  components: {
    LoadingSpinner,
    MaintenanceScreen
  },
  beforeCreate () {
    this.requestedEnvelope = {
      envelopeFingerprint: this.$route.params.envelopeFingerprint,
      widgetCode: this.$route.params.widgetCode
    }

    this.$store.commit('setRequestedEnvelope', this.requestedEnvelope)

    axios.defaults.baseURL = process.env.VUE_APP_API_URL

    // Set the feature flags once Launch darkly is ready
    this.$launchDarkly.on('ready', () => this.setFlags(this.$launchDarkly.allFlags()))
    // Listen for changes to featureFlags in LaunchDarkly and then set the updated features in the store
    this.$launchDarkly.on('change', () => this.setFlags(this.$launchDarkly.allFlags()))
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      featureEnabled: 'featureFlags/featureEnabled'
    }),
    isLoading () {
      return this.$store.getters['auth/authorising']
    }
  },
  methods: {
    ...mapActions({
      setFlags: 'featureFlags/SET_FLAGS'
    })
  },
  watch: {
    user: {
      deep: true,
      handler (newVal) {
        if (newVal) {
          // Set the user once it is changed in the Vuex store
          Sentry.setUser({
            id: newVal.party_id,
            email: newVal.party_email,
            company_id: newVal.company_id
          })

          // Let launch darkly know company
          this.$launchDarkly.identify({
            key: newVal.company_id,
            kind: 'user'
          })
        }
      }
    }
  }
}
</script>

<style lang="sass">
  @import '@/styles/manifest.sass'
  #app
    position: relative

  .error-message
    text-align: center
</style>
